import { createAsyncComponentWithReducer, getLogger } from '../../shared';
import type * as ReactType from 'react';
import type { SearchBoxContainerHandle } from 'owa-search/lib/types/SearchBoxContainerHandle';
import type { Store } from 'redux';

export interface SearchBoxProps {
    searchBoxRef: React.RefObject<SearchBoxContainerHandle>;
}

export const SearchBoxAsync = createAsyncComponentWithReducer<SearchBoxProps>(() =>
    import(/* webpackChunkName: "SearchBox" */ './searchBoxLazyIndex').catch(error => {
        // Loading js chuck has failed
        getLogger().log('ChuckLoadFailed', {
            component: 'peopleHubSearch',
            error: error ? error.message : undefined,
        });
        return Promise.reject();
    })
) as ReactType.ComponentType<{
    store: Store<{}>;
    searchBoxRef: React.RefObject<SearchBoxContainerHandle>;
}>;
